import { useTranslation } from 'react-i18next';

import { IconManager } from '@speeki/icons';

import SpeekiLogo from '@assets/images/speeki_logo.svg';

import { LanguageSelect } from '@components/molecules/LanguageSelect/LanguageSelect';
import { openContactSupport } from '@components/organisms/ContactSupportModal/openContactSupport';

import { useResponsive } from '@utils/hooks/useResponsive';

import { EnterEntityForm } from '@domains/auth/molecules/EnterEntityForm/EnterEntityForm';
import { WelcomeSection } from '@domains/auth/organisms/WelcomeSection/WelcomeSection';

import {
    CartTitle,
    ContentCard,
    ContentWrapper,
    Footer,
    Header,
    HeaderLogo,
    MobileDescription,
    MobileTitle,
    WelcomeHintBanner,
    WelcomePageWrapper,
} from './WelcomePage.styled';

export const WelcomePage = () => {
    const { t } = useTranslation();
    const isMd = useResponsive('md');

    return (
        <WelcomePageWrapper>
            <Header>
                <HeaderLogo src={SpeekiLogo} />
                <LanguageSelect />
            </Header>
            <ContentWrapper>
                {!isMd && <WelcomeSection />}
                <ContentCard testId="fVDnQdk">
                    {isMd ? (
                        <>
                            <MobileTitle>{t('WELCOME_TITLE')}</MobileTitle>
                            <MobileDescription>
                                {t('WELCOME_CARD_DESCRIPTION')}
                            </MobileDescription>
                        </>
                    ) : (
                        <CartTitle>{t('ENTER_ENTITY_TITLE')}</CartTitle>
                    )}
                    <EnterEntityForm />
                    <WelcomeHintBanner>
                        <IconManager icon={'SvgInfo'} size={16} />
                        <WelcomeHintBanner.Description>
                            {t('NOT_SURE_ABOUT_ENTITY_NAME')}{' '}
                            <WelcomeHintBanner.Anchor
                                aria-haspopup={'dialog'}
                                href={'#contact-support'}
                                onClick={openContactSupport}
                            >
                                {t('CONTACT_SPEEKI_TEAM')}
                            </WelcomeHintBanner.Anchor>
                        </WelcomeHintBanner.Description>
                    </WelcomeHintBanner>
                </ContentCard>
            </ContentWrapper>
            <Footer />
        </WelcomePageWrapper>
    );
};
